import { createTheme } from "@mui/material";

export const theme = createTheme({
  root: {
    margin: "inherit"
  },
  components: {
    // Name of the component
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: "0px"
        }
      }
    }
  },
  typography: {
    margin: 0,
    head: {
      fontSize: "100px",
    },
    head1: {
      fontSize: "64px",
    },
    head2: {
      fontSize: "36px",
    },
    head3: {
      fontSize: "28px",
    },
    head4: {
      fontSize: "24px",
    },
    head5: {
      fontSize: "20px",
    },
    body1: {
      fontSize: "18px",
    },
    body2: {
      fontSize: "16px",
    },
    body3: {
      fontSize: "14px",
    },
    body4: {
      fontSize: "12px",
    },
    body5: {
      fontSize: "11px",
    },
    body6: {
      fontSize: "10px",
    },
    body7: {
      fontSize: "7px",
    },
  },
});

// $fontHead: 100px;
// $fontHead1: 64px;
// $fontHead2: 36px;
// $fontHead3: 28px;
// $fontHead4: 24px;
// $fontHead5: 20px;

// $fontBody1: 18px;
// $fontBody2: 16px;
// $fontBody3: 14px;
// $fontBody4: 12px;
// $fontBody5: 11px;
// $fontBody6: 10px;
// $fontBody7: 7px;
